import React, { useContext, useState } from 'react';
import _ from 'lodash';
import { AES, enc, mode, pad } from 'crypto-js';

import { FetchContext, HttpMethods } from './FetchContext';
import { useAggregatedState } from '../../helpers';

// wpApAdminSettings is a global variable defined in WP
// To allow webpack to build and not giving error we are
// creating a local reference only if it exists 
// (basically when the javascript is executed inside the WordPress context)
let _wpApAdminSettings = {};
if (typeof variable !== 'wpApAdminSettings') {
	_wpApAdminSettings = window['wpApAdminSettings'];
}

const compileRoute = (route, params) => {
	if (params) {
		const props = Object.getOwnPropertyNames(params);
		if (props && props.length > 0) {
			route = `${route}?`
			props.filter(x => params[x] !== null && params[x] !== undefined).forEach(prop => route = `${route}${prop}=${params[prop]}&`);
			route = route.substr(0, route.length - 1);
		}
	}
	return route;
}

const compileRouteWP = (route, params) => {
	if (params) {
		const props = Object.getOwnPropertyNames(params);
		if (props && props.length > 0) {
			route = `${route}&`
			props.filter(x => params[x] !== null && params[x] !== undefined).forEach(prop => route = `${route}${prop}=${params[prop]}&`);
			route = route.substr(0, route.length - 1);
		}
	}
	return route;
}

const pluginRoute = (route, params) => {
	return compileRoute(`${_wpApAdminSettings.internalAPIUrl}myfastapp/v1/${route}`, params);
}

const pluginRoute2 = (route, params) => {
	return compileRouteWP(`${_wpApAdminSettings.internalAPIUrl}myfastapp/v1/${route}`, params);
}

const azureRoute = (route, params) => {
	return compileRoute(`${_wpApAdminSettings.externalAPIUrl}${route}`, params);
}

const wordpressRoute = (route, params) => {
	return compileRouteWP(`${_wpApAdminSettings.internalAPIUrl}wp/v2/${route}`, params);
}


export const ApiRoutes = {
	Plugin: {
		GetSettings                : (params) => pluginRoute("settings"					  , params),
		UpdateSettings             : (      ) => pluginRoute("settings"								 ),
		GetMenuItems               : (params) => pluginRoute("menuItems"					  , params),
		UpdateMenuItems            : (      ) => pluginRoute("menuItems"								 ),
		ResetSettings              : (      ) => pluginRoute("resetSettings"							 ),
		GetAppConfig               : (params) => pluginRoute("mfa-config2"				  , params),
		CheckPendingConfigChanges  : (params) => pluginRoute("checkPendingConfigChanges", params),
		UpdateLiveConfig				: (      ) => pluginRoute("updateLiveConfig"						 ),
		UpdateAppConfig				: (      ) => pluginRoute("updateAppConfig"						 )
	},
	Azure: {
		GetTodaySalt					: (params) => azureRoute("PLG_GetBuildSalt"			  , params),
		GetBuilds					   : (params) => azureRoute("PLG_GetBuildInfo"			  , params),
		CheckLicense				   : (params) => azureRoute("PLG_CheckLicense"			  , params),
		CreateBuild						: (params) => azureRoute("PLG_CreateBuild"			  , params),
		//-- da rimuovere
		CreateAppleCertificates		: (		) => azureRoute("CreateAppleCertificates"				 ),
		CreateGoogleCertificates	: (		) => azureRoute("CreateGoogleCertificates"			 ) 
		//--
	},
	Wordpress: {
		GetCategories					: (params) => wordpressRoute("categories", params),
		GetPages							: (params) => pluginRoute2("pages"		  , params),
	//	GetPages							: (params) => wordpressRoute("pages", params),
	},
	FontAwesome: {
		GetIconClasses					: 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css'
	},
}

export const RestApiContext = React.createContext(null);

const { Provider } = RestApiContext;
export const RestApiProvider = ({ ...props }) => {
	const { fetchAuthorized, fetchWpAuthorized } = useContext(FetchContext);
	const [state, setState] = useAggregatedState({
	});

	const sleep = (ms) => {
		return new Promise(resolve => setTimeout(resolve, ms));
	}

	const btoaSafe = (value) => {
		return btoa(value).replace(/\+/g, '-').replace(/\//g, '_');
	}

	function safeEncode(json1) {
		var data1 = stringToHex(json1);
		var data2 = { envelope: data1 };
		var json2 = JSON.stringify(data2);
		return json2;
	}

	function stringToHex(str) {
		let hex = '';
		for (let i = 0; i < str.length; i++) hex += ('0' + str.charCodeAt(i).toString(16)).slice(-2);
		return hex;
	}

	/* --- Plugin ------------------- */

	const getSettingsAsync = async () => {
		const r = await fetchAuthorized(ApiRoutes.Plugin.GetSettings(), {
			method: HttpMethods.GET
		});
		const settings = await r.json();
		return settings;
	}

	const updateSettingsAsync = async ({ settings }) => {
		const r = await fetchAuthorized(ApiRoutes.Plugin.UpdateSettings(), {
			method: HttpMethods.POST,
			body: safeEncode(JSON.stringify(settings))
		});
	}

	const getMenuItemsAsync = async () => {
		const r = await fetchAuthorized(ApiRoutes.Plugin.GetMenuItems(), {
			method: HttpMethods.GET
		});
		const menuItems = await r.json();
		return menuItems;
	}

	const updateMenuItemsAsync = async ({ menuItems }) => {
		const r = await fetchAuthorized(ApiRoutes.Plugin.UpdateMenuItems(), {
			method: HttpMethods.POST,
			body: safeEncode(JSON.stringify(menuItems))
		});
	}

	const resetSettingsAsync = async () => {
		const r = await fetchAuthorized(ApiRoutes.Plugin.ResetSettings(), {
			method: HttpMethods.DELETE
		});
		window.top.location.reload();
	}

	const getAppConfigAsync = async () => {
		const r = await fetchAuthorized(ApiRoutes.Plugin.GetAppConfig(), {
			method: HttpMethods.GET
		});
		const config = await r.json();
		return config;
	}

	const checkConfigChangesAsync = async () => {
		const r = await fetchAuthorized(ApiRoutes.Plugin.CheckPendingConfigChanges(), {
			method: HttpMethods.GET
		});
		const configStatus = await r.json();
		return configStatus;
	}

	const updateLiveConfigAsync = async () => {
		const r = await fetchAuthorized(ApiRoutes.Plugin.UpdateLiveConfig(), {
			method: HttpMethods.POST
		});
		const storedFile = await r.json();
		return storedFile;
	}

	const updateAppConfigAsync = async () => {
		const r = await fetchAuthorized(ApiRoutes.Plugin.UpdateAppConfig(), {
			method: HttpMethods.POST
		});
		const storedFile = await r.json();
		return storedFile;
	}

	/* --- Azure ------------------- */

	const getTodaySaltAsync = async () => {
		const r = await fetchAuthorized(ApiRoutes.Azure.GetTodaySalt(), {
			method: HttpMethods.GET
		});
		const base64Salt = await r.text();
		return atob(base64Salt);
	}

	const getEncryptedTextAsync = async (salt, text) => {
		const key = enc.Utf8.parse(salt);
		const iv = enc.Utf8.parse(salt);
		text = AES.encrypt(enc.Utf8.parse(text), key,
			{
				keySize: 128 / 8,
				iv: iv,
				mode: mode.CBC,
				padding: pad.Pkcs7
			}).toString();

		return text;
	}

	const getBuildsAsync = async () => {
		const r = await fetchAuthorized(ApiRoutes.Azure.GetBuilds(), {
			method: HttpMethods.GET
		});
		const bundle = await r.json();
		return bundle;
	}

	const getLiveViewerQrCodeAsync = async () => {
		let qrCodeInfo = {
			configUrl: _wpApAdminSettings.siteUrl
		};
		return qrCodeInfo;
	}

	const checkLicenseAsync = async () => {

		/*
			NotFound  = 0,
			Active	 = 1,
			Expired	 = 2
		*/

		const r = await fetchAuthorized(ApiRoutes.Azure.CheckLicense(), {
			method: HttpMethods.GET
		});
		const license = await r.json();
		return license;
	}

	const createBuildAsync = async (buildConfig) => {
		const todaySalt = await getTodaySaltAsync();
		const p12Password = await getEncryptedTextAsync(todaySalt, buildConfig.iOS.p12Password);
		const keyStoreAlias = await getEncryptedTextAsync(todaySalt, buildConfig.android.keyAlias);
		const keyStorePassword = await getEncryptedTextAsync(todaySalt, buildConfig.android.keyPassword);
		buildConfig = {
			...buildConfig,
			iOS: {
				...(buildConfig.iOS),
				p12Password: btoaSafe(p12Password)
			},
			android: {
				...(buildConfig.android),
				keyAlias: btoaSafe(keyStoreAlias),
				keyPassword: btoaSafe(keyStorePassword)
			}
		};

		const r = await fetchAuthorized(ApiRoutes.Azure.CreateBuild(), {
			method: HttpMethods.POST,
			body: JSON.stringify(buildConfig)
		});
		const buildStatus = await r.json();
		return buildStatus;
	}

	const createAppleCertsAsync = async ({ keyId, teamId, email, bundleId, adminEmail }) => {
		const r = await fetchAuthorized(ApiRoutes.Azure.CreateAppleCertificates(), {
			method: HttpMethods.POST,
			body: JSON.stringify({ keyId, teamId, email, bundleId, adminEmail })
		});
		const certsInfo = await r.json();
		return certsInfo;
	}

	const createGoogleCertsAsync = async ({ keystoreAlias, email, bundleId, adminEmail }) => {
		const r = await fetchAuthorized(ApiRoutes.Azure.CreateGoogleCertificates(), {
			method: HttpMethods.POST,
			body: JSON.stringify({ keystoreAlias, email, bundleId, adminEmail })
		});
		const certsInfo = await r.json();
		return certsInfo;
	}

	/* --- Wordpress ------------------- */

	const getWordPressCategoriesAsync = async (page = 1, perPage = 100) => {
		const r = await fetchWpAuthorized(ApiRoutes.Wordpress.GetCategories({ page, per_page: perPage, orderBy: "name", order: "asc" }), {
			method: HttpMethods.GET
		});
		const categories = await r.json();
		return categories;
	}

	const getWordPressPagesAsync = async (page = 1, perPage = 100) => {
		const r = await fetchWpAuthorized(ApiRoutes.Wordpress.GetPages({ page, per_page: perPage }), {
			method: HttpMethods.GET
		});
		const pages = await r.json();
		return pages;
	}

	/* --- FontAwesome ------------------- */

	const getIconClassesAsync = async () => {

		const r = await fetch(ApiRoutes.FontAwesome.GetIconClasses, {
			method: HttpMethods.GET
		});

		const icons = (await r.text())
			.split(".fa")
			.filter(x => x.includes("content"))
			.map(x => ({
				cssClass: "fa fa" + x.split(":")[0],
				code: x.split(":")[2].substr(2, 4)
			}));

		return icons;
	}

	return (
		<Provider value={{
			// Plugin
			getSettingsAsync,
			updateSettingsAsync,
			getMenuItemsAsync,
			updateMenuItemsAsync,
			resetSettingsAsync,
			getAppConfigAsync,
			checkConfigChangesAsync,
			updateLiveConfigAsync,
			updateAppConfigAsync,
			getIconClassesAsync,
			getBuildsAsync,
			// Azure
			checkLicenseAsync,
			getLiveViewerQrCodeAsync,
			getBuildsAsync,
			createBuildAsync,
			createAppleCertsAsync,
			createGoogleCertsAsync,
			// Wordpress
			getWordPressCategoriesAsync,
			getWordPressPagesAsync,
		}}>
			{props.children}
		</Provider>
	);
}